import { Component, Input, OnInit } from '@angular/core';
import { LoggerService } from '@wdpr/ra-angular-logger';

import { CtaButton } from '@finder/shared/components/campaign-cta/campaign-cta-interface';
import { CommonModule } from '@angular/common';
import { SafeHtmlPipe } from '@finder/shared/utils/pipes/safe-html/safe-html.pipe';
import { IconTooltipComponent } from '@finder/shared/components/icon-tooltip/icon-tooltip.component';
import { ButtonComponent } from '@finder/shared/components/button/button.component';

@Component({
    selector: 'finder-overview-cta',
    templateUrl: './overview-cta.component.html',
    styleUrls: ['./overview-cta.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        SafeHtmlPipe,
        IconTooltipComponent,
        ButtonComponent
    ]
})
export class OverviewCtaComponent implements OnInit {
    @Input() data: any;

    title: string;
    text: string;
    tooltip: string;
    tooltipDescription: string;
    button: CtaButton;

    constructor(
        private logger: LoggerService,
    ) {}

    ngOnInit() {

        if (!this.data) {
            this.logger.warn('OverviewCtaComponent: no `data` set');

            return;
        }

        this.setText();
        this.setButton();
    }

    private setText() {
        this.title = this.data.title;
        this.text = this.data.text;
        this.tooltip = this.data.tooltip;
        this.tooltipDescription = this.data.tooltipDescription;
    }

    private setButton() {
        if (!this.data.button) {
            return;
        }

        this.button = {
            link: this.data.button.link,
            target: '_self',
            label: this.data.button.label,
        };
    }
}
